<div id="academy-courses" class="page-layout simple">
    <!-- HEADER -->
    <div class="header primary p-16 p-sm-24" fxLayout="column" fxLayoutAlign="center center">

        <div class="hero-text">
            <!-- <mat-icon [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}" class="hero-icon">school</mat-icon> -->
            <h1 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <!-- WELCOME TO CERTIFY {{origen.infoLanding}} -->
                {{'WIZARD.LANDING.PRODUCTO.RESULTADOS.TITULO' | translate}}
            </h1>
            <h3 [@animate]="{value:'*',params:{delay:'100ms', y:'25px'}}">
                <!-- Our courses will step you through the process of building a small application, or adding a new feature
                  to an existing application. -->
            </h3>
        </div>

    </div>
    <!-- / HEADER -->
    <!-- CONTENT -->
    <div class="content p-24">
      <app-centros-de-trabajo></app-centros-de-trabajo>

      <!-- <app-menu-resultados></app-menu-resultados> -->

      <!-- <mat-horizontal-stepper labelPosition="bottom" #stepper>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.1' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/1.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.2' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/2.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.3' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/3.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.4' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/4.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.5' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/5.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.6' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/6.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.7' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/7.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.7' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/8.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.8' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/9.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.9' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/10.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperNext>Next</button>
                <button mat-button matStepperPrevious>Back</button>
              </div>
            </div>
        </mat-step>
        <mat-step >
            <ng-template matStepLabel>{{'WIZARD.LANDING.PRODUCTO.RESULTADOS.STEPS.10' | translate}}</ng-template>
            <div fxLayout="column" fxLayoutAlign="start stretch">
              <img src="./assets/images/norm35/resuTest/11.png" alt="">
              <div class="" fxLayout="row" fxLayoutAlign="start center">
                <button mat-button matStepperPrevious>Back</button>
                <button mat-button (click)="stepper.reset()">Reset</button>
              </div>
            </div>
        </mat-step>
      </mat-horizontal-stepper> -->
    </div>
    <!-- / CONTENT -->
</div>
